import React from "react";

import PolicyPicker from "../../../../components/PolicyPicker";
import {
  getRouteFormProperty,
  setRouteFormProperty,
} from "../../../../slices/routes";
import { useDispatch, useSelector } from "../../../../store";
import {
  EntityInfo,
  UpstreamTunnel,
  useGetPolicyQuery,
} from "../../../../store/pomeriumApi";

type UpstreamTunnelSshPolicyPickerProps = {
  readonly: boolean;
};
const UpstreamTunnelSshPolicyPicker = ({
  readonly,
}: UpstreamTunnelSshPolicyPickerProps) => {
  const dispatch = useDispatch();
  const organizationId = useSelector((state) => state.current.organizationId);
  const upstreamTunnel = useSelector(
    getRouteFormProperty("upstreamTunnel", {}),
  ) as UpstreamTunnel;
  const { data } = useGetPolicyQuery(
    {
      organizationId,
      policyId: upstreamTunnel?.sshPolicyId || "",
    },
    {
      skip: !upstreamTunnel?.sshPolicyId,
    },
  );
  const selectedPolicies: EntityInfo[] = upstreamTunnel?.sshPolicyId
    ? [
        {
          id: upstreamTunnel.sshPolicyId,
          name: data?.name || upstreamTunnel.sshPolicyId,
          updatedAt: data?.updatedAt || "",
        },
      ]
    : [];

  const handleChange = (newPolicies: EntityInfo[]) => {
    const newUpstreamTunnel: UpstreamTunnel =
      newPolicies.length > 0
        ? {
            // pick the last policy id so there can only be 0 or 1 policy
            sshPolicyId: newPolicies[newPolicies.length - 1].id,
          }
        : {};
    dispatch(
      setRouteFormProperty({
        path: "upstreamTunnel",
        value: newUpstreamTunnel,
      }),
    );
  };
  return (
    <PolicyPicker
      readonly={readonly}
      policies={selectedPolicies}
      onChange={handleChange}
      showAdd
    />
  );
};
export default UpstreamTunnelSshPolicyPicker;
